import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';

const useInsertDepartureOperation = () => {
  const { enqueueSnackbar } = useSnackbar();

  const insertRequest = (
    getDepartureOperationList,
    setIsInsertModalOpen,
    setInsertLoading,
    payload,
  ) => {
    axiosClient
      .post(`Operation/Departure/Insert`, {
        zoneGuid: payload.zoneGuid,
        title: payload.title,
        description: payload.description,
        voucherType: payload.voucherType,
        storeID: payload.storeID,
      })
      .then(res => {
        if (res.status === 200) {
          enqueueSnackbar(`افزودن با موفقیت انجام شد`, { variant: 'success' });
          getDepartureOperationList?.();
          setIsInsertModalOpen?.(false);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setInsertLoading?.(false));
  };

  return { insertRequest };
};

export default useInsertDepartureOperation;
